import { toNumber } from '@lib/strings/toNumber';

const CURRENCY_PARTS_LENGTH = 2;

export const dollarsToCents = (dollars: string): number => {
  const parts = dollars.split('.');
  if (parts.length !== CURRENCY_PARTS_LENGTH) {
    throw new Error('You need to use the format "111.11" for currencies.');
  }
  return toNumber(parts.join('')) ?? 0;
};
